import {
  JobPipelineCandidateSheetActivity,
  JobPipelineCandidateSheetCandidacyComments,
} from "@/components";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const JobPipelineCandidateSheetCandidacyCommentsAndActivity = ({
  candidacyId,
  candidateFirstName,
  candidateLastName,
}: {
  // TODO: Better mechanism for accessing these values?
  candidacyId: string;
  candidateFirstName: string;
  candidateLastName: string;
}) => {
  return (
    <Tabs
      // This is important to prevent the tabs from being controlled by keyboard shortcuts.
      activationMode="manual"
      defaultValue="comments"
      // TODO: See if this is the best way to handle this.
      // This ensures that the tabs go back to the default state when the selected candidacy changes.
      key={candidacyId}
    >
      <div className="px-6 pb-4">
        <TabsList>
          {/* TODO: Better way to handle the width of the tabs. */}
          <TabsTrigger className="w-[105px]" value="comments">
            Comments
          </TabsTrigger>
          <TabsTrigger className="w-[85px]" value="activity">
            Activity
          </TabsTrigger>
        </TabsList>
      </div>
      <TabsContent value="comments">
        <JobPipelineCandidateSheetCandidacyComments
          candidacyId={candidacyId}
          className="px-6"
        />
      </TabsContent>
      <TabsContent value="activity">
        <JobPipelineCandidateSheetActivity
          candidacyId={candidacyId}
          candidateFirstName={candidateFirstName}
          candidateLastName={candidateLastName}
          className="px-6"
        />
      </TabsContent>
    </Tabs>
  );
};
